import { stringify } from 'query-string';

import { addError } from '@src/validations';
import { apiGet } from '@src/services/api/helpers';
import productTitleFromSlug from '@src/utils/productTitleFromSlug';

const getResourcePublishedAt = (values, source) => (
    values[source.publishedAt]
    ?? values[source.datePublishedAt]
    ?? values.published_at
);

const isScheduledResource = (values, source) => {
    if (values[source.status] !== 'published') {
        return false;
    }

    const publishedAt = getResourcePublishedAt(values, source);
    if (!publishedAt) {
        return false;
    }

    const publishedAtDate = new Date(publishedAt);
    return !Number.isNaN(publishedAtDate.getTime()) && publishedAtDate > new Date();
};

async function checkInvalidProducts(values, source) {
    const platformIds = values[source.platforms] || [];
    const selectedProducts = values[source.products] || [];
    const resourceAllowsDraftProducts = values[source.status] === 'draft' || isScheduledResource(values, source);

    if (platformIds.length === 0 || selectedProducts.length === 0) {
        return [];
    }

    const query = { 'platform_ids[]': platformIds };
    const url = `/products?${stringify(query)}`;

    const allProductsQuery = { 'slugs[]': selectedProducts, include_hidden: true };
    const allProductsUrl = `/products/all?${stringify(allProductsQuery)}`;

    try {
        const [response, allProductsResponse] = await Promise.all([
            apiGet(url),
            apiGet(allProductsUrl),
        ]);

        const validProducts = response.data.products;
        const allProducts = allProductsResponse.data.products;

        const validSlugs = validProducts.map((product) => product.slug);

        let invalidProducts = selectedProducts.filter((slug) => {
            if (validSlugs.includes(slug)) {
                return false;
            }

            const product = allProducts.find((p) => p.slug === slug);
            if (resourceAllowsDraftProducts && product?.status === 'draft') {
                return false;
            }

            return true;
        });

        if (invalidProducts.length > 0) {
            invalidProducts = invalidProducts.map((slug) => productTitleFromSlug(slug));
        }

        return invalidProducts;
    } catch (error) {
        console.error('Error checking invalid products:', error);
        return [];
    }
}

export async function validateProducts(values, errors, source) {
    const invalidProducts = await checkInvalidProducts(values, source);
    if (invalidProducts.length > 0) {
        addError(
            errors,
            source.products,
            `Platform not available for selected product(s): ${invalidProducts.join(', ')}`,
        );
    }
}
